import { Component, OnInit } from '@angular/core';
import { Ng2ImgMaxService } from 'ng2-img-max';

import { AuthenicationService } from '../../_services/authenication.service';
import {environment} from '../../../environments/environment';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {ToasterService} from "../../_services/toaster.service";
import {UserService} from "../../_services/user.service";
import {DoctorService} from "../../_services/doctor.service";
import {DynamicScriptLoaderServiceService} from "../../_services/dynamic-script-loader-service.service";
import {first} from "rxjs/operators";
import {Ng4LoadingSpinnerService} from "ng4-loading-spinner";
import { S3uploadsService } from './../../_services/s3uploads.service'
declare var $: any;

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.css']
})
export class EditProfileComponent implements OnInit {

  userdetaild: string;
  usersid: string;
  baseUrl: string = environment.baseUrl;
  editDocForm: FormGroup;
  userid: any;
  code: string;
  userdata: any;
  contactlist: any;
  returnUrl: string;
  submitted = false;
  selectedfile: File = null;
  selectedfile1: Array<File> = [];
  doctorid: string;
  imgtype = 'image/*';
  png = 'image/png';
  jpg = 'image/jpg';
  jpeg = 'image/jpeg';
  doc = 'application/msword';
  docx = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
  pdf = 'application/pdf';

  degree: any[] = [];
  languages: any[] = [];
  speciality: any[] = [];
  // session_mode: any[] = [];
  mp_location: any[] = [];
  specialisation: any[] = [];
  ShowFilter = true;
  limitSelection = false;
  dropdownSettings: any = {};
  dropdownSettings1: any = {};
  uid = '';
  imageData: string;
  certi: any[] = [];

  constructor(private formBuilder: FormBuilder, private router: Router, private route: ActivatedRoute, private authenicationService: AuthenicationService, private toaster: ToasterService, private userservice: UserService, private doctorservice: DoctorService, private ng2ImgMax: Ng2ImgMaxService, private spinnerService: Ng4LoadingSpinnerService, private S3uploadsService: S3uploadsService) { }

  ngOnInit() {

    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }

    if (!this.userdetaild || this.userdetaild['users_usertype'] == 'employee2') {
      this.router.navigate(['/']);
    }

    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';

    this.route.queryParams.subscribe(params => {
      this.userid = params['did'] || this.userdetaild['_id'];
    });

    this.uid = this.userdetaild['_id'];
    //this.userid = this.userdetaild['_id'];

    // if (this.userdetaild['users_usertype'] == 'doctor' || this.userdetaild['users_usertype'] == 'admin'){
    //   this.getDoctorProfile(this.userid);
    // }

    this.getDoctorProfile(this.userid);
    this.getSpecialisation();
    this.getLanguages();
    this.getSpeciality();
    this.getDegree();


    // this.degree = [
    //   { item_id: 'M.Phil', item_text: 'M.Phil' },
    //   { item_id: 'MA/Msc', item_text: 'MA/Msc' },
    //   { item_id: 'BA', item_text: 'BA' },
    //   { item_id: 'MD', item_text: 'MD' },
    //   { item_id: 'Others', item_text: 'Others' }
    // ];

    // this.session_mode = [
    //   { item_id: 'f2f', item_text: 'Face To Face' },
    //   { item_id: 'video', item_text: 'Video' },
    //   { item_id: 'Phone', item_text: 'Phone' }
    // ];

    // this.specialisation = [
    //   { item_id: 'Clinical Psychologist', item_text: 'Clinical Psychologist' },
    //   { item_id: 'Counselling Psychologist', item_text: 'Counselling Psychologist' },
    //   { item_id: 'Psychotherapist', item_text: 'Psychotherapist' },
    //   { item_id: 'Life Coach', item_text: 'Life Coach' },
    //   { item_id: 'Expressive Arts Therapist', item_text: 'Expressive Arts Therapist' },
    //   { item_id: 'Career Counsellor', item_text: 'Career Counsellor' },
    //   { item_id: 'Relationship Therapist', item_text: 'Relationship Therapist' },
    //   { item_id: 'Psychiatrist', item_text: 'Psychiatrist' },
    //   { item_id: 'Others', item_text: 'Others' }
    // ];

    // this.languages = [
    //   { item_id: 'English', item_text: 'English' },
    //   { item_id: 'Hindi', item_text: 'Hindi' },
    //   { item_id: 'Bengali', item_text: 'Bengali' },
    //   { item_id: 'Telugu', item_text: 'Telugu' },
    //   { item_id: 'Marathi', item_text: 'Marathi' },
    //   { item_id: 'Tamil', item_text: 'Tamil' },
    //   { item_id: 'Urdu', item_text: 'Urdu' },
    //   { item_id: 'Kannada', item_text: 'Kannada' },
    //   { item_id: 'Gujarati', item_text: 'Gujarati' },
    //   { item_id: 'Odia', item_text: 'Odia' },
    //   { item_id: 'Punjabi', item_text: 'Punjabi' },
    //   { item_id: 'Malayalam', item_text: 'Malayalam' },
    //   { item_id: 'Assamese', item_text: 'Assamese' }
    // ];

    // this.speciality = [
    //   { item_id: 'ADHD', item_text: 'ADHD' },
    //   { item_id: 'Addictions', item_text: 'Addictions' },
    //   { item_id: 'Anxiety', item_text: 'Anxiety' },
    //   { item_id: 'Anger Management', item_text: 'Anger Management' },
    //   { item_id: 'BiPolar Disorder', item_text: 'BiPolar Disorder' },
    //   { item_id: 'Borderline Personality Disorder', item_text: 'Borderline Personality Disorder' },
    //   { item_id: 'Child and Adolescent Behaviour', item_text: 'Child and Adolescent Behaviour' },
    //   { item_id: 'Couples/Marital Therapy', item_text: 'Couples/Marital Therapy' },
    //   { item_id: 'Career Counselling', item_text: 'Career Counselling' },
    //   { item_id: 'Cognitive Behavioral Therapy', item_text: 'Cognitive Behavioral Therapy' },
    //   { item_id: 'Dyslexia', item_text: 'Dyslexia' },
    //   { item_id: 'Depression', item_text: 'Depression' },
    //   { item_id: 'Eating Disorder', item_text: 'Eating Disorder' },
    //   { item_id: 'Expat Adjustment Issues', item_text: 'Expat Adjustment Issues' },
    //   { item_id: 'Family Therapy', item_text: 'Family Therapy' },
    //   { item_id: 'Grief and Loss', item_text: 'Grief and Loss' },
    //   { item_id: 'Infidelity', item_text: 'Infidelity' },
    //   { item_id: 'OCD', item_text: 'OCD' },
    //   { item_id: 'Parenting', item_text: 'Parenting' },
    //   { item_id: 'Phobias', item_text: 'Phobias' },
    //   { item_id: 'Positive Parenting Program', item_text: 'Positive Parenting Program' },
    //   { item_id: 'Screen Addiction', item_text: 'Screen Addiction' },
    //   { item_id: 'Sexuality/LGBT Issues', item_text: 'Sexuality/LGBT Issues' },
    //   { item_id: 'Sexual Issues', item_text: 'Sexual Issues' },
    //   { item_id: 'Self Esteem Issues', item_text: 'Self Esteem Issues' },
    //   { item_id: 'Stress Management', item_text: 'Stress Management' },
    //   { item_id: 'Trauma', item_text: 'Trauma' }
    // ];

    // this.mp_location = [
    //   { item_id: 'North Delhi', item_text: 'North Delhi' },
    //   { item_id: 'Central Delhi', item_text: 'Central Delhi' },
    //   { item_id: 'Central Delhi', item_text: 'Central Delhi' },
    //   { item_id: 'South Delhi', item_text: 'South Delhi' },
    //   { item_id: 'Noida', item_text: 'Noida' },
    //   { item_id: 'Gurgaon', item_text: 'Gurgaon' },
    // ];

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: this.ShowFilter
    };

    this.dropdownSettings1 = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: this.ShowFilter
    };

    this.dropdownSettings1 = Object.assign({}, this.dropdownSettings1, { allowSearchFilter: this.ShowFilter });


    this.editDocForm = this.formBuilder.group({
      users_name: ['', [Validators.required, Validators.minLength(3)]],
      photo: [''],
      rci: [{value: '', disabled: true}],
      users_mobile: ['', [Validators.required]],
      location: ['', [Validators.required]],
      pronouns: ['', [Validators.required]],
      city: ['', [Validators.required]],
      // users_usertype: ['doctor', [Validators.required]],
      degree: ['', [Validators.required]],
      specialisation: ['', [Validators.required]],
      experience: ['', [Validators.required]],
      language: ['', [Validators.required]],
      gender: ['', [Validators.required]],
      about: ['', [Validators.required]],
      specialities: ['', [Validators.required]],
      certificates: [''],
      // mp_location: [''],
      sequence: [''],
      // session_mode: ['', [Validators.required]],
      own_space: [''],
      space_address: [''],
    });




  }

  toogleShowFilter() {
    this.ShowFilter = !this.ShowFilter;
    this.dropdownSettings = Object.assign({}, this.dropdownSettings, { allowSearchFilter: this.ShowFilter });
  }

  handleLimitSelection() {
    if (this.limitSelection) {
      this.dropdownSettings = Object.assign({}, this.dropdownSettings, { limitSelection: 2 });
    } else {
      this.dropdownSettings = Object.assign({}, this.dropdownSettings, { limitSelection: null });
    }
  }

  getDoctorProfile(id){
    this.doctorservice.getDoctorById(id)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            // this.toaster.showSuccess('Add Doctor', data.ResponseMessage);
            this.userdata = data.doctorsList[0];
            this.editForm(this.userdata);
          } else {
            console.log('Doctor', data.ResponseMessage);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          console.log('Doctor', error.error.ResponseMessage);
        });
  }

  get f() { return this.editDocForm.controls; }

  fileUpload(event) {
    let image = event.target.files[0];
    if (image.type === this.jpg || image.type === this.png || image.type === this.jpeg) {

      this.ng2ImgMax.compressImage(image, 1, true).subscribe(
        result => {
          this.selectedfile = result;
        },
        error => {
          // console.log(JSON.stringify(error));
          this.toaster.showError('😢 Oh no!', error);
        }
      );

      return true;
    } else {
      this.editDocForm.controls.photo.reset();
      this.toaster.showError('File Type', 'Only Images are allowed');
      return false;
    }
  }

  fileUpload1(event) {

    this.selectedfile1 = event.target.files as Array<File>;
    for (let i = 0; i < this.selectedfile1.length; i++) {
      if (this.selectedfile1[i].type === this.doc || this.selectedfile1[i].type === this.docx || this.selectedfile1[i].type === this.pdf) {
        return true;
      } else {
        this.editDocForm.controls.certificates.reset();
        this.toaster.showError('File Type', 'Only Documents are allowed');
        return false;
      }
    }
  }


  editForm(data: any) {
    // console.log(data);
    this.usersid = data.docid._id;
    this.doctorid = data._id;
    this.code = (data.docid.users_code)?data.docid.users_code:'';
    let selecteddegree = [];
    let selectedlanguage = [];
    let selectedspeciality = [];
    // let selectedsession_mode = [];
    // let mpLocation = [];
    let specialisation = [];

    data.degrees.forEach(function each(item) {
      selecteddegree.push({ item_id: item._id, item_text: item.name });
    });
    // data.location.forEach(function each(item) {
    //   mpLocation.push({ item_id: item, item_text: item });
    // });
    data.languages.forEach(function each(item) {
      selectedlanguage.push({ item_id: item._id, item_text: item.name });
    });
    data.specialities.forEach(function each(item) {
      selectedspeciality.push({ item_id: item._id, item_text: item.name });
    });
    data.specialisations.forEach(function each(item) {
      specialisation.push({ item_id: item._id, item_text: item.name });
    });
    // data.session_mode.forEach(function each(item) {
    //   let txt;
    //   if (item == 'f2f'){
    //     txt = 'Face To Face'
    //   }
    //   else{
    //     txt = 'Video'
    //   }
    //   selectedsession_mode.push({ item_id: item, item_text: txt });
    // });


    this.editDocForm.setValue({
      users_name: data.docid.users_name,
      users_mobile: data.docid.users_mobile,
      photo: '',
      // location: (data.docid.users_city)?data.docid.users_city:'',
      degree: selecteddegree,
      specialisation: specialisation,
      experience: data.experience,
      gender: (data.gender)?data.gender:'',
      about: (data.about)?data.about:'',
      pronouns: (data.pronouns)?data.pronouns:'',
      rci: (data.rci)?data.rci:'',
      language: selectedlanguage,
      specialities: selectedspeciality,
      certificates: '',
      own_space: (data.own_space)?data.own_space:'',
      sequence: (data.sequence)?data.sequence:'',
      // session_mode: selectedsession_mode,
      space_address: (data.space_address)?data.space_address:'',
      location: (data.location)?data.location.state:'',
      city: (data.location)?data.location.city:'',
    });


  }

  onSubmit() {
    let degree1 = [];
    let languages1 = [];
    let speciality1 = [];
    let session_mode1 = [];
    // let mp_location1 = [];
    let specialisation = [];

    this.spinnerService.show();
    // stop here if form is invalid
    if (this.editDocForm.invalid) {
      
      this.spinnerService.hide();
      return;
    }

    this.editDocForm.controls.degree.value.forEach(function each(item) {
      if (item.item_id != undefined){
        degree1.push(item.item_id);
      }
      else{
        degree1.push(item);
      }

    });


    this.editDocForm.controls.specialisation.value.forEach(function each(item) {
      if (item.item_id != undefined){
        specialisation.push(item.item_id);
      }
      else{
        specialisation.push(item);
      }

    });

    this.editDocForm.controls.language.value.forEach(function each(item) {
      if (item.item_id != undefined){
        languages1.push(item.item_id);
      }
      else{
        languages1.push(item);
      }
    });

    this.editDocForm.controls.specialities.value.forEach(function each(item) {
      if (item.item_id != undefined){
        speciality1.push(item.item_id);
      }
      else{
        speciality1.push(item);
      }
    });
    // this.editDocForm.controls.session_mode.value.forEach(function each(item) {
    //   session_mode1.push(item.item_id);
    // });
    let location = {
      country: 'India', 
      state: this.editDocForm.controls.location.value,
      city: this.editDocForm.controls.city.value,
  }
    const addUserPayload = {
      users_name: this.editDocForm.controls.users_name.value,
      users_mobile: this.editDocForm.controls.users_mobile.value,
      locations: location,
      degrees: degree1.toString(),
      specialisation: specialisation.toString(),
      experience: this.editDocForm.controls.experience.value,
      gender: this.editDocForm.controls.gender.value,
      about: this.editDocForm.controls.about.value,
      sequence: this.editDocForm.controls.sequence.value,
      pronouns: this.editDocForm.controls.pronouns.value,
      languages: languages1.toString(),
      specialities: speciality1.toString(),
      // session_mode: session_mode1.toString(),
      own_space: (this.editDocForm.controls.own_space.value)?this.editDocForm.controls.own_space.value:'N/A',
      space_address: (this.editDocForm.controls.space_address.value)?this.editDocForm.controls.space_address.value:'N/A',
      // mp_location: mp_location1.toString()
    };

    const formdata = new FormData();

    formdata.append('users_name', addUserPayload.users_name);
    formdata.append('doc_id', this.doctorid);
    formdata.append('users_mobile', addUserPayload.users_mobile);
    // formdata.append('users_city', addUserPayload.users_city);
    formdata.append('users_id', this.usersid);
    formdata.append('userid', this.uid);
    // if (this.selectedfile !== null) {
    //   formdata.append('photo', this.selectedfile);
    // }
    // if (this.selectedfile1) {
    //   const files: Array<File> = this.selectedfile1;
    //   for (let i = 0; i < files.length; i++) {
    //     formdata.append('certificates', files[i], files[i].name);
    //   }
    // }
    formdata.append('degrees', addUserPayload.degrees);
    formdata.append('specialisations', addUserPayload.specialisation);
    formdata.append('experience', addUserPayload.experience);
    formdata.append('gender', addUserPayload.gender);
    formdata.append('pronouns', addUserPayload.pronouns);
    formdata.append('about', addUserPayload.about);
    formdata.append('languages', addUserPayload.languages);
    formdata.append('specialities', addUserPayload.specialities);
    formdata.append('location', JSON.stringify(addUserPayload.locations));
    // formdata.append('session_mode', addUserPayload.session_mode);
    formdata.append('own_space', addUserPayload.own_space);
    formdata.append('space_address', addUserPayload.space_address);
    // formdata.append('mp_location', addUserPayload.mp_location);
    formdata.append('sequence', addUserPayload.sequence);
    formdata.append('profile_pic', this.imageData);
    formdata.append('certi', this.certi.toString());
    // console.log(formdata.getAll('photo'));
    this.updateDoctor(formdata);
  }

  updateDoctor(payload: FormData) {
    this.doctorservice.updateDoctorData(payload)
      .pipe(first())
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            
              this.spinnerService.hide();
              this.router.navigate(['/doctorlist']);

          } else {
            this.toaster.showError('Update Profile', data.ResponseMessage);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          this.toaster.showError('Update Profile', error.error.ResponseMessage);
        });
  }


  getSpecialisation(){
    this.doctorservice.getSpecialisation()
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            // this.toaster.showSuccess('Add Doctor', data.ResponseMessage);
            let resData = data.Data;
            let newData = resData.map(item => ({ item_id: item._id, item_text: item.name }));
            this.specialisation = newData;
          } 
        },
        error => {
          console.log('Doctor', error);
        });
  }

  getLanguages(){
    this.doctorservice.getLanguages()
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            let resData = data.Data;
            let newData = resData.map(item => ({ item_id: item._id, item_text: item.name }));
            this.languages = newData;
          } 
        },
        error => {
          console.log('Doctor', error);
        });
  }

  getSpeciality(){
    this.doctorservice.getSpeciality()
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            let resData = data.Data;
            let newData = resData.map(item => ({ item_id: item._id, item_text: item.name }));
            this.speciality = newData;
          } 
        },
        error => {
          console.log('Doctor', error);
        });
  }

  getDegree(){
    this.doctorservice.getDegree()
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            let resData = data.Data;
            let newData = resData.map(item => ({ item_id: item._id, item_text: item.name }));
            this.degree = newData;
          } 
        },
        error => {
          console.log('Doctor', error);
        });
  }

  fileUploads(event) {
    let selectedfile = event.target.files[0];
    this.uploadFiles(selectedfile);
  }

  fileUploads1(event) {

    this.selectedfile1 = event.target.files as Array<File>;
    for (let i = 0; i < this.selectedfile1.length; i++) {
      this.uploadFiles1(this.selectedfile1[i]);
    }
  }

  uploadFiles1(filedata) {
    this.S3uploadsService.getSigendUrl({ filename: filedata.name, type: "USER_PICTURE" })
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            let details = data.urlDetails;
            this.certi.push(details.url);
            
            this.uploadFileViaUri(details.uri, filedata)
          } else {
            this.toaster.showError('Profile', data.ResponseMessage);
          }
        },
        error => {
          this.toaster.showError('Profile', error);
        });
  }


  uploadFiles(filedata) {
    this.S3uploadsService.getSigendUrl({ filename: filedata.name, type: "USER_PICTURE" })
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            let details = data.urlDetails;
            this.imageData = details.url;
            this.uploadFileViaUri(details.uri, filedata)
          } else {
            this.toaster.showError('Profile', data.ResponseMessage);
          }
        },
        error => {
          this.toaster.showError('Profile', error);
        });
  }

  uploadFileViaUri(uri, payload) {
    this.S3uploadsService.uploadFileViaUri(uri, payload)
      .subscribe(
        (data: any) => {
          // this.toaster.showError('Edit Events', "Image uploaded");
        },
        error => {
          this.toaster.showError('Edit Events Error', error);
        });
  }


}
